import { connect } from 'react-redux';
import UploadProgress from '../components/upload_progress';

const mapStateToProps = state => ({
  active: state.getIn(['compose', 'is_uploading']),
  progress: state.getIn(['compose', 'progress']),
});

export default connect(mapStateToProps)(UploadProgress);



// WEBPACK FOOTER //
// ./app/javascript/mastodon/features/compose/containers/upload_progress_container.js